import { render } from "./SectorForm.vue?vue&type=template&id=cb26f03a&scoped=true"
import script from "./SectorForm.vue?vue&type=script&lang=js"
export * from "./SectorForm.vue?vue&type=script&lang=js"

import "./SectorForm.vue?vue&type=style&index=0&id=cb26f03a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb26f03a"]])

export default __exports__